var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"event-link",attrs:{"to":{ name: 'mqmark', params: { trackid: _vm.trackid, subject : _vm.subject } }}},[_c('div',{staticClass:"event-card -shadow p-2 m-2"},[_c('h4',{staticClass:"title mt-1"},[_vm._v(" "+_vm._s(_vm.subject)+" ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"9"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }